import { Dimensions } from 'react-native';
var _Dimensions$get = Dimensions.get('window'),
  width = _Dimensions$get.width,
  height = _Dimensions$get.height;
var _ref = width < height ? [width, height] : [height, width],
  shortDimension = _ref[0],
  longDimension = _ref[1];
var guidelineBaseWidth = 375;
var guidelineBaseHeight = 667;
export var scale = size => shortDimension / guidelineBaseWidth * size;
export var verticalScale = size => longDimension / guidelineBaseHeight * size;
export var moderateScale = function moderateScale(size, factor) {
  if (factor === void 0) {
    factor = 0.5;
  }
  return size + (scale(size) - size) * factor;
};
export var moderateVerticalScale = function moderateVerticalScale(size, factor) {
  if (factor === void 0) {
    factor = 0.5;
  }
  return size + (verticalScale(size) - size) * factor;
};
export var scaledHeight = (width, height) => height * scale(width) / width;